//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Knee_fracture",
  data() {
    return {
      form: {
        value1: "0",
        value2: "0",
        value3: "0",
        value4: "0",
        value5: "0",
      },
      hasScore: false,
      disabled: false,
     
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "0";
      } else {
        // chf+mi+periphVasc+cerebroVasc+pulmonary+liver+ulcer+dm+renal*2+tumor*2+metastatic*6+leukemia*2+lymphoma*2+aids*6+tissue+dementia+hemiplegia*2
        let result =
          form.value1 +
          form.value2 +
          form.value3 +
          form.value4 +
          form.value5 
         

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Knee_fracture.vue